export default Object.freeze({
  ADMIN_ROLES: ['global-admin', 'GlobalAdmin', 'ADMIN', 'agent_only_trial'],
  PROJECT_ONLY: 'project-access-only',
});
